import Impressum from '@/views/Impressum/index.vue'

const ImpressumRouter = {
  path: '/Impressum',
  name: 'Impressum',
  component: Impressum,
  props: (route) => ({
    secret: route.query.secret,
    token: route.query.token
  })
}

export default ImpressumRouter
